import { TeamsTabs } from '@/components/sections/TeamsTabs'
import { PageHero } from '@/components/layout/PageHero'

export function TeamsPage() {
  return (
    <>
      <PageHero
        eyebrow="Rosters &amp; Age Groups"
        title="Teams."
        intro="Boys and Girls squads from U-04 through U-18, plus open Pool selection. Pick a division, then an age group to view the roster, season chart, and next match."
        image="https://cosmosfc.org/wp-content/uploads/2022/03/S6-1024x670.jpg"
        crumbs={[{ label: 'Teams' }]}
      />
      <section className="py-20">
        <div className="container-narrow">
          <TeamsTabs />
        </div>
      </section>
    </>
  )
}
